import s from './Loader.module.css';
import { PortalComponent } from '../PortalComponent';
import { useEffect, useState } from 'react';

export const Loader = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);
  return (
    <PortalComponent>
      <div className={s['loader']}>
        {isVisible && (
          <svg className={s['loader__spinner']} viewBox='0 0 50 50'>
            <circle
              className={s['loader__path']}
              cx='25'
              cy='25'
              r='20'
              fill='none'
              strokeWidth='5'
            ></circle>
          </svg>
        )}
      </div>
    </PortalComponent>
  );
};
